import React from 'react';
import {Pagination, Table} from "antd";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import SafeCreationModal from "./SafeCreationModal";
import SAPopconfirm from "../../common/confirmation/SAPopconfirm";
import DateFormat from "../../common/format/DateFormat";
import moment from 'moment';

const Column = Table.Column;

class SafesManagementTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      safes: [],
      currentPage: 1,
      currentPageSize: 10,
      selectedMode: 'create',      // modes = create || edit
    }
  }

  componentDidMount() {
    this.props.dispatchFetchDealerSafes({page: this.state.currentPage-1, size: this.state.currentPageSize});
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchDealerSafes && nextProps.fetchDealerSafes.safes) {
      const {safes} = nextProps.fetchDealerSafes;
      this.setState({safes});
    }
  };

  onSafeAdd = () => {
    this.setState({selectedSafe: undefined, selectedMode: 'create'});
    this.props.showSafeModal();
  };

  onSafeEdit = (row) => {
    this.setState({selectedSafe: row, selectedMode: 'edit'});
    this.props.showSafeModal();
  };

  onSafeDelete = (row) => {
    this.props.dispatchDeleteDealerSafe({safeNumber: row.id})
  };

  onPageOptionsChange = (page, size) => {
    this.setState({
      currentPage: page,
      currentPageSize: size
    });
    this.props.dispatchFetchDealerSafes({page: page-1, size: size});
  };

  render() {
    const {intl: {formatMessage}, fetchDealerSafes, fetchDealerSafes: {totalElements, loading, error}, saveDealerSafe: {showModal}} = this.props;
    const {currentPage, safes, selectedSafe, selectedMode} = this.state;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.codes-configuration.title'})}
          </h2>
          <div className="box-heading__right">
            <button onClick={this.onSafeAdd} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.add'})}</button>
          </div>
        </header>

        <div className="box__body">
          {(fetchDealerSafes.loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="table-wrapper__body">
              {error && error.code &&
                <div className="alert alert--error">
                  {formatMessage({id: error.code})}
                </div>
              }
              <Table className="table overview-table"
                     dataSource={safes}
                     loading={loading}
                     rowKey={'safeNumber'}
                     pagination={false}
                     rowClassName={(record) => {
                       const {lastCodeChangeDate} = record;
                       if (lastCodeChangeDate && moment(lastCodeChangeDate).isBefore(moment().subtract(14, 'days'))) {
                         return "is-on-alert"
                       }
                       return null;
                     }}
              >
                <Column
                  title={formatMessage({id:'safe.number'})}
                  dataIndex="safeNumber"
                  key="safeNumber"
                />
                <Column
                  title={formatMessage({id:'safe.code'})}
                  dataIndex="safeCode"
                  key="safeCode"
                />
                <Column
                  title={formatMessage({id:'safe.lastChange'})}
                  dataIndex="lastCodeChangeDate"
                  key="lastCodeChangeDate"
                  render = {(value) => <DateFormat className="ml-1" layout="dateTimeLong" date={value}/>}
                />
                <Column
                  render={(text, row) => (
                    <a onClick={() => this.onSafeEdit(row)}>{formatMessage({id: 'action.edit'})}</a>
                  )}
                />
                <Column
                  render={(text, row) => (
                    <SAPopconfirm action="delete" onConfirm={e => this.onSafeDelete(row, e)}>
                      <a>{formatMessage({id: 'action.delete'})}</a>
                    </SAPopconfirm>
                  )}
                />
              </Table>

              {showModal &&
                <SafeCreationModal selectedSafe={selectedSafe} selectedMode={selectedMode}/>
              }
            </div>
          )}

          <footer className="table-wrapper__footer">
            <Pagination className="pagination" current={currentPage}
                        defaultCurrent={1} onChange={this.onPageOptionsChange}
                        showSizeChanger onShowSizeChange={this.onPageOptionsChange}
                        pageSizeOptions={["10", "25", "50", "100"]} defaultPageSize={10}
                        total={totalElements}
            />
          </footer>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchDealerSafes: state.fetchDealerSafes,
  saveDealerSafe: state.saveDealerSafe,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealerSafes: (parameters) => dispatch({type: 'FETCH_DEALER_SAFES.REQUEST', parameters}),
  dispatchDeleteDealerSafe: (parameters) => dispatch({type: 'DELETE_DEALER_SAFE.REQUEST', ...parameters}),
  showSafeModal: () => dispatch({type: 'SHOW_SAFE_MODAL'}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(SafesManagementTable), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/safes/management/SafesManagementTable.js